import { lazy } from "react";
import Activity from "../Pages/Landing/Activity";
// import Certification from "../Pages/Landing/Certification";
// import Classroom from "../Pages/Landing/Classroom";
// import Profile from "../Pages/Landing/Profile";
// import Settings from "../Pages/Landing/Settings";
// import Content from "../Pages/Landing/Content";

const Certification = lazy(() => import("../Pages/Landing/Certification"));
const Classroom = lazy(() => import("../Pages/Landing/Classroom"));
const Profile = lazy(() => import("../Pages/Landing/Profile"));
const Settings = lazy(() => import("../Pages/Landing/Settings"));
const Content = lazy(() => import("../Pages/Landing/Content"));

const ROUTE_CONFIG = [
  {
    path: "activity",
    component: Activity,
    roles: ["ADMIN", "STUDENT", "CREATOR"],
  },
  {
    path: "certification",
    component: Certification,
    roles: ["ADMIN", "STUDENT", "CREATOR"],
  },
  {
    path: "classroom",
    component: Classroom,
    roles: ["ADMIN", "STUDENT", "CREATOR"],
  },
  {
    path: "profile",
    component: Profile,
    roles: ["ADMIN", "STUDENT"],
  },
  {
    path: "settings",
    component: Settings,
    roles: ["ADMIN", "STUDENT"],
  },
  //   {
  //     path: "jobs",
  //     component: Jobs,
  //     roles: ["ADMIN"],
  //   },
  {
    path: "Content",
    component: Content,
    roles: ["ADMIN", "CREATOR"],
  },
  // {
  //   path: "CreateCourseAndModule",
  //   component: CreateCourseAndModule,
  //   roles: ["ADMIN", "CREATOR"],
  // },
  // {
  //   path: "CreateAssessment",
  //   component: CreateAssessment,
  //   roles: ["ADMIN", "CREATOR"],
  // },
  // {
  //   path: "CreateFinalAssessment",
  //   component: CreateFinalAssessment,
  //   roles: ["ADMIN", "CREATOR"],
  // },
  // {
  //   path: "MapAssessment",
  //   component: MapAssessment,
  //   roles: ["ADMIN", "CREATOR"],
  // },
];

export { ROUTE_CONFIG };
 